// @module Ames.UserManual.UserManual
define('Ames.UserManual.UserManual.View'
,	[
	'ames_usermanual_usermanual.tpl'
	
	,	'Backbone'
    ]
, function (
	ames_usermanual_usermanual_tpl
	
	,	Backbone
)
{
    'use strict';

	// Field format (custitem_user_manual, Rich Text, entries separated by commas / line breaks):
	//   URL              -> positional user manual: 1st = English, 2nd = Spanish
	//   Label|URL        -> named document (e.g. "Cooling Guide|https://..."); shown below the manuals
	// Labels must not contain commas or pipes.
	var MANUAL_LABELS = [
		{ lang: 'English', title: 'Operation And Maintenance Guide', cta: 'Download' }
	,	{ lang: 'Español', title: 'Guía de Operación y Mantenimiento', cta: 'Descargar' }
	];

	var ENTRY_RE = /(?:([^|,\n]*?)\s*\|\s*)?(https?:\/\/[^\s,<>"'|]+)/gi;

	// @class Ames.UserManual.UserManual.View @extends Backbone.View
	return Backbone.View.extend({

		template: ames_usermanual_usermanual_tpl

	,	initialize: function (options) {
			this.pdp = options.application.getComponent('PDP');
			var iteminfo = this.pdp.getItemInfo();
			var item = (iteminfo && iteminfo.item) || {};
			this.mpn = item.mpn;
			this.manuals = this.parseManuals(item.custitem_user_manual);
		}

		// @method parseManuals Extracts one entry per URL from the field value.
		// The field is Rich Text, so the value may arrive wrapped in HTML (<p>…</p>, <br>)
		// with entity-encoded ampersands (&amp;).
		// @param {String} raw @return {Array<Object>}
	,	parseManuals: function parseManuals (raw)
		{
			if (!raw) { return []; }

			var text = String(raw)
				.replace(/<br\s*\/?>/gi, '\n')
				.replace(/<\/p>/gi, '\n')
				.replace(/<[^>]*>/g, ' ')          // strip remaining HTML tags
				.replace(/&amp;/gi, '&')           // decode entities that can appear in a URL / label
				.replace(/&#39;|&apos;/gi, "'")
				.replace(/&quot;/gi, '"')
				.replace(/&nbsp;/gi, ' ')
				.replace(/&lt;/gi, '<')
				.replace(/&gt;/gi, '>');

			var manuals = [];
			var documents = [];
			var match;

			ENTRY_RE.lastIndex = 0;
			while ((match = ENTRY_RE.exec(text)) !== null)
			{
				var label = (match[1] || '').replace(/^\s+|\s+$/g, '');
				var url = match[2];

				if (label)
				{
					documents.push({ url: url, title: label, cta: 'Download', isManual: false });
				}
				else
				{
					var labels = MANUAL_LABELS[manuals.length] || MANUAL_LABELS[0];
					manuals.push({ url: url, lang: labels.lang, title: labels.title, cta: labels.cta, isManual: true });
				}
			}

			return manuals.concat(documents);
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Ames.UserManual.UserManual.View.Context
	,	getContext: function getContext()
		{
			var manualCount = 0;
			for (var i = 0; i < this.manuals.length; i++) { if (this.manuals[i].isManual) { manualCount++; } }

			//@class Ames.UserManual.UserManual.View.Context
			return {
				// @property {String} mpn
				mpn: this.mpn
				// @property {Array<Object>} manuals
			,	manuals: this.manuals
				// @property {Boolean} showManual
			,	showManual: this.manuals.length > 0
				// @property {Boolean} hasMultipleManuals true when more than one positional (language) manual
			,	hasMultipleManuals: manualCount > 1
				// @property {String} heading
			,	heading: this.manuals.length > 1 ? 'User Manuals' : 'User Manual'
			};
		}
	});
});
